
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/soccer/tournament/[id]",
      function () {
        return require("private-next-pages/soccer/tournament/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/soccer/tournament/[id]"])
      });
    }
  